import { colors } from "@material-ui/core";
import React from "react";

import { toast } from "@/design-system/components/Toast/Toast";

import { Button } from "@/design-system/components/Button/Button";

import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { LinkedinIcon } from "@/components/icons/themes/logos";
import { makeRequest } from "@/util";

const OAuthModal = () => {
  return null;
};

const InstructionModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={[]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const InstructionRow = ({ setConfigModalOpen, existingConfig }) => {
  const destExists = existingConfig.id !== undefined;
  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={destExists ? "" : colors.red[600]}
      labelText={destExists ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthRow = ({ existingConfig, destination }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;
  const destExists = existingConfig.id !== undefined;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: destination.slug,
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#0a66c2]"
      leadingIcon={<LinkedinIcon className="h-4 w-4" />}
      onClick={onOpenConfigModal}
    >
      {oauthConfigured ? "Reconnect" : "Connect with LinkedIn"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
      disabled={!destExists}
    />
  );
};

const OAUTH = "OAUTH";
const INSTRUCTION = "INSTRUCTION";

const Rows = {
  [OAUTH]: OAuthRow,
  [INSTRUCTION]: InstructionRow,
};

const Modals = {
  [OAUTH]: OAuthModal,
  [INSTRUCTION]: InstructionModal,
};

const RowOrder = [INSTRUCTION, OAUTH];

const config = {
  Rows,
  RowOrder,
  Modals,
};
export default config;
